/**
 * @description 登录
 * @author zhijie.huang
 * @date 2018/9/11
 */
import Logic from './logic-base'
import Session from './session'
import MD5 from 'md5'

const loginBiz = new Logic()
const session = new Session()

loginBiz.login = function (username, password, verificationCode) {
  password = MD5(password)
  return new Promise((resolve, reject) => {
    this.ajax({
      ...this.REQUEST_OPT.login.login,
      data: {
        userCode: username,
        passWord: password,
        verificationCode: verificationCode
      }
    }).then((data) => {
      session.saveSession(data.accessToken, data.loginCustomerId, username)
      resolve(data)
    }).catch((err) => {
      reject(err)
    })
  })
}

loginBiz.logout = function () {
  return new Promise((resolve, reject) => {
    this.ajax({
      ...this.REQUEST_OPT.login.logout
    }, true).then((data) => {
      session.clearSession()
      resolve(data)
    }).catch((err) => {
      session.clearSession()
      reject(err)
    })
  })
}

loginBiz.getVerificationCode = function (data) {
  return new Promise((resolve, reject) => {
    this.ajax({
      ...this.REQUEST_OPT.login.getVerificationCode,
      data: data
    }, true).then((data) => {
      resolve(data)
    }).catch((err) => {
      reject(err)
    })
  })
}

export default loginBiz
